import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ShieldAlert, ArrowLeft, LogOut } from 'lucide-react';

const UnauthorizedPage = () => {
  const { role, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-[#161513] flex items-center justify-center px-4 sm:px-6 lg:px-8 relative">
      {/* Logo Background */}
      <div 
        className="absolute top-0 left-0 right-0 h-[400px] bg-cover bg-center bg-no-repeat opacity-20 z-0 pointer-events-none"
        style={{ backgroundImage: `url('/src/assets/logo.gif')` }}
      ></div>
      
      <div className="max-w-md w-full text-center relative z-10">
        <div className="w-20 h-20 bg-[#0CB4E4]/20 rounded-full mx-auto flex items-center justify-center">
          <ShieldAlert className="h-10 w-10 text-[#0CB4E4]" />
        </div>
        <h1 className="mt-6 text-3xl font-extrabold text-white">Access Denied</h1>
        <p className="mt-2 text-lg text-gray-300">
          You don't have permission to access this page.
        </p>
        
        <div className="mt-4 p-4 bg-[#161513] rounded-lg text-left border border-[#0CB4E4]/30">
          <h3 className="font-medium text-[#0CB4E4]">Current Role: {role || 'Unknown'}</h3>
          <p className="mt-1 text-sm text-gray-300">
            This page requires a different role level to access. If you believe this is an error, please contact an administrator.
          </p>
        </div>
        
        <div className="mt-6 space-y-3">
          {role && (
            <Link
              to={role === 'waitlisted' ? '/waitlist' : '/dashboard'}
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-md text-[#161513] bg-[#0CB4E4] hover:bg-[#0CB4E4]/90 w-full justify-center transition-colors"
            >
              <ArrowLeft className="mr-2 h-5 w-5" />
              {role === 'waitlisted' ? 'Back to Waitlist' : 'Back to Dashboard'}
            </Link>
          )}
          
          <button
            onClick={handleLogout}
            className="inline-flex items-center px-6 py-3 border border-[#0CB4E4]/30 shadow-md text-base font-medium rounded-md text-white bg-[#161513] hover:bg-[#161513]/80 w-full justify-center transition-colors"
          >
            <LogOut className="mr-2 h-5 w-5" />
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
